const pageIdRegex = /<(?:Master)?Page\s[^>]*?(?<=\s)id="(.+?)".*?>/;
export const getPageId = async (siteFileSystem, { structure }) => {
    const structureXmlContent = await siteFileSystem.readFile(structure);
    const [match, pageId] = structureXmlContent.match(pageIdRegex) ?? [];
    if (!match) {
        throw new Error('pageId not found in wml');
    }
    return pageId;
};
const mapWmlFiles = async (documentStructure, callbackFn) => {
    const [structure, data, style] = await Promise.all([
        callbackFn(documentStructure.structure, 'structure'),
        callbackFn(documentStructure.data, 'data'),
        callbackFn(documentStructure.style, 'style')
    ]);
    return { structure, data, style };
};
const writeWmlFiles = async (siteFileSystem, documentStructure, wml) => {
    const filesContent = convertWmlExportToFiles(wml);
    await mapWmlFiles(documentStructure, (filePath, fileName) => siteFileSystem.writeFile(filePath, filesContent[fileName]));
};
const removeWmlFiles = async (siteFileSystem, documentStructure) => {
    await mapWmlFiles(documentStructure, (filePath) => siteFileSystem.removeFile(filePath));
};
export const writeWml = async (siteFileSystem, documentStructure, pageData) => {
    if (pageData === null) {
        return removeWmlFiles(siteFileSystem, documentStructure);
    }
    return writeWmlFiles(siteFileSystem, documentStructure, pageData.data);
};
export const readWml = async (siteFileSystem, documentStructure) => {
    const filesContent = await mapWmlFiles(documentStructure, async (filePath) => await siteFileSystem.readFile(filePath));
    return convertFilesToWmlExport(filesContent);
};
const indentedStringify = (data) => JSON.stringify(data, undefined, 2);
export const convertWmlExportToFiles = (wmlExport) => {
    const dataWithoutVersion = JSON.parse(wmlExport.data.content);
    const dataWithVersion = indentedStringify({ ...dataWithoutVersion, version: wmlExport.version });
    return {
        structure: wmlExport.structure.content,
        style: wmlExport.style.content,
        data: dataWithVersion
    };
};
export const convertFilesToWmlExport = (filesContent) => {
    const { version, ...dataWithoutVersion } = JSON.parse(filesContent.data);
    return {
        structure: { type: 'xml', content: filesContent.structure },
        data: { type: 'json', content: indentedStringify(dataWithoutVersion) },
        style: { type: 'css', content: filesContent.style },
        version
    };
};
